import React from 'react';
import { Mail, Lock, User, AlertCircle, ArrowRight, Loader2 } from 'lucide-react';
import { AuthInputField } from '../AuthInputField/AuthInputField';
import { useSignupForm } from './useSignupForm';
import './SignupForm.css';

export function SignupForm({ onSubmit, isLoading, error }) {
  const {
    name,
    setName,
    email,
    setEmail,
    password,
    setPassword,
    confirmPassword,
    setConfirmPassword,
    localError,
    handleSubmit,
  } = useSignupForm({ onSubmit });

  const displayError = localError || error;

  return (
    <form className="auth-signup-form" onSubmit={handleSubmit}>
      {displayError && (
        <div className="auth-form-error">
          <AlertCircle size={16} />
          <span>{displayError}</span>
        </div>
      )}

      <AuthInputField
        id="signup-page-name"
        label="이름 / 닉네임"
        placeholder="홍길동"
        value={name}
        onChange={(e) => setName(e.target.value)}
        icon={User}
        required
      />

      <AuthInputField
        id="signup-page-email"
        label="이메일"
        type="email"
        placeholder="example@aimus.com"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        icon={Mail}
        required
        autoComplete="email"
      />

      <AuthInputField
        id="signup-page-password"
        label="비밀번호 (6자 이상)"
        type="password"
        placeholder="비밀번호를 입력하세요"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        icon={Lock}
        required
        autoComplete="new-password"
      />

      <AuthInputField
        id="signup-page-confirm"
        label="비밀번호 확인"
        type="password"
        placeholder="비밀번호를 다시 입력하세요"
        value={confirmPassword}
        onChange={(e) => setConfirmPassword(e.target.value)}
        icon={Lock}
        required
        autoComplete="new-password"
      />

      <button
        type="submit"
        className="auth-submit-btn"
        disabled={isLoading || !email || !password}
      >
        {isLoading ? (
          <>
            <Loader2 size={16} className="auth-submit-btn__spinner" />
            <span>가입 처리 중...</span>
          </>
        ) : (
          <>
            <span>무료로 가입하기</span>
            <ArrowRight size={16} />
          </>
        )}
      </button>
    </form>
  );
}
